import styled from "styled-components";
import { getImageURL } from "../../utilities";
// "blurLeft": "blur-blue-left.svg",
// "blurRight": "blur-blue-right.svg",
// "dotsBlue": "dots-blue-four.svg",
// "dotsRed": "dots-red-five.svg",
// "cardHeaderBig": "card-header-bg-big.svg",
// "cardHeaderSmall": "card-header-bg-small.svg"
const StyledCardSection = styled.section`
  @media (min-width: 1700px) {
    & .xxl-max-width {
      max-width: 1600px;
    }
  }

  //desktop to mobile
  & {
    background-image: url(${({ $imageContent }) =>
        getImageURL($imageContent.dotsBlue)}),
      url(${({ $imageContent }) => getImageURL($imageContent.blurRight)}),
      url(${({ $imageContent }) => getImageURL($imageContent.blurLeft)}),
      url(${({ $imageContent }) => getImageURL($imageContent.dotsRed)}),
      url(${({ $imageContent }) => getImageURL($imageContent.blurRight)});
    background-repeat: no-repeat;
    background-position: left 0rem, right -6rem, left 10%, right 35%, right 55%;
  }
  & .title {
    margin-top: 1rem;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 45px;
    line-height: 155.5%;
    color: #083f88;
  }
  & .title span:last-of-type {
    color: #00aae4;
    padding-left: 1rem;
    font-size: inherit;
  }

  & .bottomLine {
    background-color: #00aae4;
    border-radius: 20px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 35px;
    text-align: center;
    padding: 1rem;
    color: #ffffff;
    position: relative;
    z-index: 10;
    transform: translateY(2.5rem);
    margin-bottom: 1rem;
  }
  @media (max-width: 1700px) {
    & .bottomLine {
      font-size: 24px;
      
    }
  }
  @media (max-width: 1400px) {
    & .bottomLine {
      font-size: 20px;
    
    }
  }
  @media (max-width: 1200px) {
    & .bottomLine {
      font-size: 16px;
    
    }
  }
  @media (max-width: 991px) {
    & .bottomLine {
      transform: translateY(0);
      margin: 2rem 1rem 1rem 1rem;
      font-size: 19px;
      line-height: 25px;
    }
  }
  @media (min-width: 992px) {
    & .bottomLine {
      margin-bottom:-1.5rem;
    }
  }
  @media (min-width: 768px) and (max-width: 1199px) {
    & .smallCards .small.card-col:last-of-type {
      width: 100%;
      height: 20rem;
    }
    & .smallCards .small.card-col:last-of-type .card-title-box {
      background-size: 130% 100%;
      background-image: url(${({ $imageContent }) =>
        getImageURL($imageContent.cardHeaderBig)});
    }
    &
      .smallCards
      .small.card-col:last-of-type
      :where(.card-title, .card-content) {
      text-align: center;
    }
    & .smallCards .small.card-col:last-of-type li {
      display: flex;
      justify-content: center;
    }
     {
      text-align: center;
    }
  }

  @media (max-width: 575px) {
    & .title {
      font-size: 34px;
    }
    & {
      background-image: none;
    }
  }
  @media (max-width: 350px) {
    & .title {
      font-size: 28px;
    }
    & .title span:last-of-type {
      padding-left: 0.5rem;
    }
  }
`;
export default StyledCardSection;
